module.exports = __webpack_public_path__ + "img/mails footer.85dc4374.png";